











































import Vue from 'vue';
import truncateStringMiddle from '../helpers/truncateStringMiddle';

const $ = window.jQuery;

export default Vue.extend({
	data: function () {
		return {
			i18nStrings: window.GPPA_ADMIN.strings,
		};
	},
	props: [
		'objectTypeInstance',
		'propertiesLoaded',
		'groupedProperties',
		'ungroupedProperties',
		'orderingProperty',
		'orderingMethod',
	],
	watch: {

	},
	computed: {
		orderingPropertiesGrouped: function () {
			const groupedProperties: { [groupId: string]: any[] } = {...this.groupedProperties};

			for ( const [groupId, properties] of Object.entries(groupedProperties) ) {
				groupedProperties[groupId] = properties.filter(property => property?.['orderby']);

				if (groupedProperties[groupId].length === 0) {
					delete groupedProperties[groupId];
				}
			}

			return groupedProperties;
		},
		orderingPropertiesUngrouped: function () {
			return this.ungroupedProperties?.filter((property: any) => property?.['orderby']);
		},
	},
	methods: {
		truncateStringMiddle,
	}
});
